import { ButtonMenu } from "@homebound/beam";
import { useRouteMatch } from "react-router";
import {
  createBidPackagesUrl,
  createTradesBidContractsUrl,
  createTradesPurchaseOrdersUrl,
  createTradesTradePartnersUrl,
} from "src/RouteUrls";
import { tradesPath } from "../../routesDef";

export function TradesNavMenu() {
  const isTradesPath = !!useRouteMatch([tradesPath]);
  return (
    <ButtonMenu
      key="tradesNavMenu"
      trigger={{ navLabel: "Trades", variant: "global", active: isTradesPath }}
      items={[
        { label: "Bids", onClick: createBidPackagesUrl() },
        { label: "Contracts", onClick: createTradesBidContractsUrl() },
        { label: "Purchase Orders", onClick: createTradesPurchaseOrdersUrl() },
        { label: "Trade Index", onClick: createTradesTradePartnersUrl() },
      ]}
      showActiveBorder
    />
  );
}
